import BaseApi from '../../base/base'

export interface AiChatThreadSummary {
  id: number
  title: string | null
  featureType: string
  examId: number | null
  createdAt: string
  updatedAt: string
}

export interface AiChatThreadMessage {
  id: number
  role: 'user' | 'assistant' | 'system'
  content: string
  reasoningContent?: string
  model?: string
  stoppedByUser?: boolean
  attachments?: Array<{ url: string; filename: string }>
  createdAt: string
}

export interface AiChatThreadDetail {
  thread: AiChatThreadSummary
  messages: AiChatThreadMessage[]
}

export interface CreateAiChatThreadParams {
  title?: string
  featureType?: string
  examId?: number
  lessonId?: number
}

export default class AiChatThreadsApi extends BaseApi {
  constructor() {
    super()
  }

  async index(params: { examId?: number; featureType?: string } = {}): Promise<AiChatThreadSummary[]> {
    this.path = '/admin/ai_chat_threads'
    const response = await this.getRequest(params)
    return response.data
  }

  async create(params: CreateAiChatThreadParams): Promise<AiChatThreadSummary> {
    this.path = '/admin/ai_chat_threads'
    const response = await this.postRequest(params)
    return response.data
  }

  async show(id: number): Promise<AiChatThreadDetail> {
    this.path = `/admin/ai_chat_threads/${id}`
    const response = await this.getRequest()
    return response.data
  }

  async update(id: number, params: { title: string }): Promise<AiChatThreadSummary> {
    this.path = `/admin/ai_chat_threads/${id}`
    const response = await this.patchRequest(params)
    return response.data
  }

  async delete(id: number): Promise<void> {
    this.path = `/admin/ai_chat_threads/${id}`
    await this.deleteRequest()
  }
}
